import { ChangeDetectorRef, Component, EventEmitter, Injector, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppComponentBase } from '../../app/app-component-base';
import { StringsHelper } from '../helpers/StringsHelper';

@Component({
    selector: 'app-alert',
    templateUrl: 'app.alert.component.html'
})

export class AppAlertComponent extends AppComponentBase implements OnInit, OnDestroy {
    private subscription: Subscription;
    private acceptCountdownTimer: any;
    message: any = { cancelTitle: '', acceptTitle: '' };
    display = false;
    displayConfirmation = false;
    acceptDisabledRemaining = 0;
    acceptDisabled = false;
    acceptEvent: EventEmitter<any>;
    closeEvent: EventEmitter<any>;

    dialogColorStyle = '';
    buttonColorStyle = '';

    constructor(
        injector: Injector,
        private readonly changeDetector: ChangeDetectorRef
    ) { super(injector); }

    ngOnInit() {
        this.subscription = this.alertService.getMessage().subscribe(message => {
            this.clearAcceptCountdown();
            this.message = message;
            this.dialogColorStyle = '';
            this.buttonColorStyle = '';
            this.display = false;
            this.displayConfirmation = false;
            this.acceptDisabledRemaining = 0;
            this.acceptDisabled = false;

            if (message) {
                if (message.type === 'confirm') {
                    this.displayConfirmation = true;
                    this.startAcceptCountdown(message.acceptDisabledSeconds);

                    if (message.colorStyle) {
                        this.dialogColorStyle = 'dialog-' + message.colorStyle;
                        this.buttonColorStyle = 'p-button-' + message.colorStyle;
                    }
                } else {
                    this.display = true;
                    this.dialogColorStyle = 'dialog-' + message.type;
                    this.buttonColorStyle = message.type === 'error' ? 'p-button-danger' : 'p-button-' + message.type;
                }
            }
        });
    }

    ngOnDestroy() {
        this.clearAcceptCountdown();
        this.subscription.unsubscribe();
    }

    onClose(): void {
        if (this.message.close) {
            this.closeEvent = new EventEmitter<any>();
            this.closeEvent.subscribe(this.message.close);
            this.closeEvent.emit(null);

            this.closeEvent.unsubscribe();
        }

        this.closeEvent = null;
        this.display = false;
        this.message = {};
    }

    onConfirmReject(): void {
        this.clearAcceptCountdown();

        if (this.acceptEvent) {
            this.acceptEvent.unsubscribe();
            this.acceptEvent = null;
        }

        this.displayConfirmation = false;
        this.message = {};
    }

    onConfirmAccept(): void {
        if (this.acceptDisabled) {
            return;
        }

        if (this.message.accept) {
            this.acceptEvent = new EventEmitter<any>();
            this.acceptEvent.subscribe(this.message.accept);
            this.acceptEvent.emit(null);
        }
        this.onConfirmReject();
    }

    processMessage(message: string): string {
        return message ? StringsHelper.replaceAll(message, '\r\n', '<br/>') : '';
    }

    hasCustomConfirmStyle(): boolean {
        return !!this.message?.styleClass;
    }

    getConfirmDialogStyle(): any {
        if (this.hasCustomConfirmStyle()) {
            return { width: '560px', minWidth: '280px' };
        }

        return { width: '400px', minWidth: '250px' };
    }

    getAcceptButtonLabel(): string {
        if (this.acceptDisabled && this.acceptDisabledRemaining > 0) {
            return `${this.message.acceptTitle} (${this.acceptDisabledRemaining})`;
        }

        return this.message.acceptTitle;
    }

    isAcceptDisabled(): boolean {
        return this.acceptDisabled;
    }

    private startAcceptCountdown(seconds?: number): void {
        const initialSeconds = Number(seconds);
        if (!initialSeconds || initialSeconds <= 0) {
            return;
        }

        this.acceptDisabledRemaining = Math.ceil(initialSeconds);
        this.acceptDisabled = true;

        const unlockAt = Date.now() + (this.acceptDisabledRemaining * 1000);
        this.acceptCountdownTimer = setInterval(() => {
            const remainingMilliseconds = unlockAt - Date.now();

            if (remainingMilliseconds <= 0) {
                this.acceptDisabledRemaining = 0;
                this.acceptDisabled = false;
                this.clearAcceptCountdown(false);
            } else {
                this.acceptDisabledRemaining = Math.ceil(remainingMilliseconds / 1000);
            }

            this.changeDetector.markForCheck();
        }, 250);
    }

    private clearAcceptCountdown(resetState: boolean = true): void {
        if (this.acceptCountdownTimer) {
            clearInterval(this.acceptCountdownTimer);
            this.acceptCountdownTimer = null;
        }

        if (resetState) {
            this.acceptDisabledRemaining = 0;
            this.acceptDisabled = false;
        }
    }
}
